import fetchApi from '../utilities/fetch/httpService'
import apiUrls  from '../utilities/consts/apiUrls'

export const getHeaderData = () =>
  fetchApi({
    url: apiUrls.misc.header_links,
    method: 'get'
  })

export const getFooterData = () =>
  fetchApi({
    url: apiUrls.misc.footer_links,
    method: 'get'
  })
  
export const getSocialLinkDetail = (title) =>
  fetchApi({
    url: apiUrls.misc.social_link_by_title.replace('$title', title),
    method: 'get'
  })
